<template>
    <div v-if="webInfo">
        <div style="width: 65%;margin: 0 auto;">
            <div class="WidgetHomeHeaderDiv">
                <div class="WidgetHomeHeader" v-for="(item, index) in webInfo.WidgetHome.part1.headerList" :key="index">
                    <el-image lazy class="WidgetHomeHeaderPic" :src="globalConfig.filePath + item.src" fit="cover"></el-image>
                    <p class="WidgetHomeHeaderLabel">{{item.label}}</p>
                </div>
            </div>
            <div class="elementTitle">{{webInfo.WidgetHome.part1.elementTitle}}</div>
            <div class="elementLabel">{{webInfo.WidgetHome.part1.elementLabel}}</div>
            <div style="height: 460px;width: 100%;display: flex;justify-content: space-between;margin-top:10px;">
                <div style="width: calc(100% - 450px);height: 100%;">
                    <div style="height: 100%;width: 100%;overflow: hidden;">
                        <div class="newsDiv">
                            <div class="newsHeader">
                                <div class="newsTitle">新闻中心</div>
                            </div>
                            <div class="newsDetailsDiv">
                                <el-row :gutter="15">
                                    <el-col :span="12" v-for="(item, index) in newsList" :key="index">
                                        <div class="newsDetails" v-if="index < 2" @click="newsDetailView(item)">
                                            <el-image lazy style="height: 120px;width: 120px;display: block;" :src="globalConfig.OAFilePath + item.noticeImg" fit="cover"></el-image>
                                            <div style="width: calc(100% - 120px);margin-left: 10px;">
                                                <div class="newsDetailsTitle">{{item.noticeName}}</div>
                                                <div class="newsDetailsContent" v-html="item.noticeContent.replace(/<[^>]+>/g, '')"></div>
                                            </div>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="15" style="margin-top: 25px;">
                                    <el-col :span="12" v-for="(item, index) in newsList" :key="index">
                                        <div class="newsDetails" v-if="1 < index && index < 4">
                                            <el-image lazy style="height: 120px;width: 120px;display: block;" :src="globalConfig.OAFilePath + item.noticeImg" fit="cover"></el-image>
                                            <div style="width: calc(100% - 120px);margin-left: 10px;">
                                                <div class="newsDetailsTitle">{{item.noticeName}}</div>
                                                <div class="newsDetailsContent" v-html="item.noticeContent.replace(/<[^>]+>/g, '')"></div>
                                            </div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                            <div class="newsNotice">
                                <template v-for="(item, index) in newsList">
                                    <div class="newsNoticeInfo" :key="index" v-if="3 < index && index < 6" @click="newsDetailView(item)">
                                        <p class="newsNoticeInfoTitle">{{item.noticeName}}</p>
                                    </div>
                                </template>
                            </div>
                            <div class="newsMoreButton" v-if="1 == 2" @click="backTop();$parent.handleTabsClick(7, 6);">查看更多</div>
                        </div>
                    </div>
                </div>
                <div style="width: 450px;height: 100%;margin-left: 10px;">
                    <video style="height: 55%;width: 100%;object-fit: cover;" :src="globalConfig.filePath + webInfo.WidgetSchool.part1.schoolInfoVideo" preload="auto" poster controls></video>
                    <el-image lazy style="height: calc(45% - 15px);width: 100%;display: block;margin-top: 15px;" :src="globalConfig.filePath + webInfo.WidgetHome.part1.src6" fit="cover"></el-image>
                </div>
            </div>
            <div style="width: 100%;margin-top:15px;">
                <div style="width: 100%;display: flex;justify-content: space-between;">
                    <div class="detailsCard">
                        <el-image lazy style="height: 155px;width: 100%;display: block;" :src="globalConfig.filePath + webInfo.WidgetHome.part1.src2" fit="cover"></el-image>
                        <p class="imgLabel">{{webInfo.WidgetHome.part1.label2}}</p>
                    </div>
                    <div class="detailsCard">
                        <el-image lazy style="height: 155px;width: 100%;display: block;" :src="globalConfig.filePath + webInfo.WidgetHome.part1.src3" fit="cover"></el-image>
                        <p class="imgLabel">{{webInfo.WidgetHome.part1.label3}}</p>
                    </div>
                    <div class="detailsCard">
                        <el-image lazy style="height: 155px;width: 100%;display: block;" :src="globalConfig.filePath + webInfo.WidgetHome.part1.src4" fit="cover"></el-image>
                        <p class="imgLabel">{{webInfo.WidgetHome.part1.label4}}</p>
                    </div>
                    <div class="detailsCard">
                        <el-image lazy style="height: 155px;width: 100%;display: block;" :src="globalConfig.filePath + webInfo.WidgetHome.part1.src5" fit="cover"></el-image>
                        <p class="imgLabel">{{webInfo.WidgetHome.part1.label5}}</p>
                    </div>
                </div>
            </div>
            <el-image lazy style="width: 100%;margin: 15px 0;" :src="globalConfig.filePath + webInfo.WidgetHome.part1.bannerSrc" fit="cover"></el-image>

            <div class="elementTitle">{{webInfo.WidgetHome.part2.elementTitle}}</div>
            <div class="elementLabel">{{webInfo.WidgetHome.part2.elementLabel}}</div>
            <div style="width: 100%;display: flex;justify-content: space-between;height: 725px;margin-bottom: 20px;margin-top:10px;">
                <div style="width: 70%;">
                    <div style="display: flex;">
                        <div :class="majorButtonActive == 0 ? 'majorButton majorButtonActive' : 'majorButton'" @click="majorButtonActive = 0">单招升学</div>
                        <div :class="majorButtonActive == 1 ? 'majorButton majorButtonActive' : 'majorButton'" @click="majorButtonActive = 1">对口升学</div>
                        <div :class="majorButtonActive == 2 ? 'majorButton majorButtonActive' : 'majorButton'" @click="majorButtonActive = 2">3+2中高职</div>
                        <div :class="majorButtonActive == 3 ? 'majorButton majorButtonActive' : 'majorButton'" @click="majorButtonActive = 3">3+4职教本科</div>
                    </div>
                    <el-row :gutter="15" style="margin-top: 15px">
                        <template v-for="(item, index) in webInfo.WidgetHome.part2.majorList[majorButtonActive]">
                            <el-col :key="index" v-if="index < 3" :span="8">
                                <el-card :body-style="{ padding: '0px' }" class="majorCard">
                                    <el-image lazy style="height: 185px;width: 100%;display: block;" :src="globalConfig.filePath + item.src" fit="cover"></el-image>
                                    <div style="padding: 10px;">
                                        <p class="majorName">{{item.majorName}}</p>
                                        <p class="majorDetails" :title="item.majorDetails">{{item.majorDetails}}</p>
                                    </div>
                                </el-card>
                            </el-col>
                        </template>
                    </el-row>
                    <el-row :gutter="15" style="margin-top: 15px">
                        <template v-for="(item, index) in webInfo.WidgetHome.part2.majorList[majorButtonActive]">
                            <el-col :key="index" v-if="index > 2" :span="8">
                                <el-card :body-style="{ padding: '0px' }" class="majorCard">
                                    <el-image lazy style="height: 185px;width: 100%;display: block;" :src="globalConfig.filePath + item.src" fit="cover"></el-image>
                                    <div style="padding: 10px;">
                                        <p class="majorName">{{item.majorName}}</p>
                                        <p class="majorDetails">{{item.majorDetails}}</p>
                                    </div>
                                </el-card>
                            </el-col>
                        </template>
                    </el-row>
                </div>
                <div style="width: calc(30% - 15px);background: #ccc;height: 100%;">
                    <div style="font-size: 24px;line-height: 60px;text-align: center;">最新报名动态</div>
                    <div id="enrollListDiv" @mouseenter="stopRollUp()" @mouseleave="restartRollUp()">
                        <div id="enrollList">
                            <div v-for="(item, index) in webInfo.WidgetHome.part2.enrollList.stuName" :key="index" class="enrollListInfo">
                                <span>{{webInfo.WidgetHome.part2.enrollList.label1[index]}}</span>
                                <span style="color: red;">{{item}}</span>
                                <span>单招成绩</span>
                                <span style="color: red;">{{webInfo.WidgetHome.part2.enrollList.label2[index]}}</span>
                            </div>
                        </div>
                        <div id="enrollListCopy"></div>
                    </div>
                    <div class="enrollPicDiv">
                        <el-image lazy style="height: 100%;width: 100%;display: block;" :src="globalConfig.filePath + webInfo.WidgetHome.part2.enrollPic.src" fit="cover"></el-image>
                    </div>
                </div>
            </div>

            <div class="elementTitle">{{webInfo.WidgetHome.part3.elementTitle}}</div>
            <div class="elementLabel">{{webInfo.WidgetHome.part3.elementLabel}}</div>
            <table class="aleiTable" border="1">
                <tr>
                    <td>热门专业</td>
                    <td>限定名额</td>
                    <td>剩余名额</td>
                    <td>毕业方向</td>
                    <td>立即报名</td>
                    <td>现在报名享受助学金</td>
                </tr>
                <tr v-for="(item, index) in webInfo.WidgetHome.part3.hotMajorList" :key="index">
                    <td>{{item.majorName}}</td>
                    <td>{{item.limit}}</td>
                    <td>{{item.surplus}}</td>
                    <td>升学&就业</td>
                    <td>
                        <el-link type="primary" style="font-size: 18px;">点击报名</el-link>
                    </td>
                    <td>助学贷款 免费邮寄入学指南</td>
                </tr>
            </table>
            <div class="hotMajorPicDiv">
                <template v-for="(item, index) in webInfo.WidgetHome.part3.hotMajorPicList">
                    <el-image :key="index" lazy class="hotMajorPic" :src="globalConfig.filePath + item.src" fit="cover"></el-image>
                </template>
            </div>
            <el-image lazy style="width: 100%;margin: 10px 0 20px 0;" :src="globalConfig.filePath + webInfo.WidgetHome.part3.bannerSrc" fit="cover"></el-image>

            <div class="elementTitle">{{webInfo.WidgetHome.part4.elementTitle}}</div>
            <div class="elementLabel">{{webInfo.WidgetHome.part4.elementLabel}}</div>
            <div class="advantageListDiv">
                <div class="advantageList">
                    <template v-for="(item, index) in webInfo.advantageList">
                        <div class="advantage" :key="index" v-if="index < 4">
                            <p class="advantageTitle" :advantageTitleIndex="index">{{item.title}}</p>
                            <p class="advantageLabel">{{item.label}}</p>
                            <div class="advantageButton">查看详情</div>
                            <el-image lazy class="advantagePic" style="height: 120px;width: 150px;display: block;" :src="globalConfig.filePath + item.src" fit="cover"></el-image>
                        </div>
                    </template>
                </div>
                <div class="advantageList">
                    <template v-for="(item, index) in webInfo.advantageList">
                        <div class="advantage" :key="index" v-if="index > 3">
                            <p class="advantageTitle" :advantageTitleIndex="index">{{item.title}}</p>
                            <p class="advantageLabel">{{item.label}}</p>
                            <div class="advantageButton">查看详情</div>
                            <el-image lazy class="advantagePic" style="height: 120px;width: 150px;display: block;" :src="globalConfig.filePath + item.src" fit="cover"></el-image>
                        </div>
                    </template>
                </div>
            </div>

            <div class="elementTitle">{{webInfo.WidgetHome.part5.elementTitle}}</div>
            <div class="elementLabel">{{webInfo.WidgetHome.part5.elementLabel}}</div>
            <div class="teacherListDiv">
                <div style="width: calc(100% - 300px);">
                    <el-image lazy style="height: 400px;width: 100%;display: block;" :src="globalConfig.filePath + webInfo.WidgetHome.part5.teacherPicList.find(obj => obj.type == teacherType).src" fit="cover"></el-image>
                </div>
                <div class="teacherListRight">
                    <div class="teacherListRightTitle">按专业看师资</div>
                    <div class="teacherListRightMajor" v-for="(item, index) in webInfo.WidgetHome.part5.majorList" :key="index" @click="teacherType = item.type">{{item.majorName}}</div>
                </div>
            </div>

            <div class="elementTitle">{{webInfo.WidgetHome.part6.elementTitle}}</div>
            <div class="elementLabel">{{webInfo.WidgetHome.part6.elementLabel}}</div>
            <div class="schoolEnvironmentDiv">
                <div class="schoolEnvironmentTabList">
                    <div :class="schoolEnvironmentTabActive == 1 ? 'schoolEnvironmentTab schoolEnvironmentTabActive' : 'schoolEnvironmentTab'" @click="schoolEnvironmentTabActive = 1">校园环境</div>
                    <div :class="schoolEnvironmentTabActive == 2 ? 'schoolEnvironmentTab schoolEnvironmentTabActive' : 'schoolEnvironmentTab'" @click="schoolEnvironmentTabActive = 2">教学环境</div>
                    <div :class="schoolEnvironmentTabActive == 3 ? 'schoolEnvironmentTab schoolEnvironmentTabActive' : 'schoolEnvironmentTab'" @click="schoolEnvironmentTabActive = 3">生活环境</div>
                    <div :class="schoolEnvironmentTabActive == 4 ? 'schoolEnvironmentTab schoolEnvironmentTabActive' : 'schoolEnvironmentTab'" @click="schoolEnvironmentTabActive = 4">学校活动</div>
                </div>
                <div class="schoolEnvironmentPicList">
                    <template v-if="schoolEnvironmentTabActive == 1">
                        <el-image class="schoolEnvironmentPic" v-for="(item, index) in webInfo.WidgetHome.part6.schoolEnvironmentPicList.a" :key="index" lazy :src="globalConfig.filePath + item" fit="cover"></el-image>
                    </template>
                    <template v-if="schoolEnvironmentTabActive == 2">
                        <el-image class="schoolEnvironmentPic" v-for="(item, index) in webInfo.WidgetHome.part6.schoolEnvironmentPicList.b" :key="index" lazy :src="globalConfig.filePath + item" fit="cover"></el-image>
                    </template>
                    <template v-if="schoolEnvironmentTabActive == 3">
                        <el-image class="schoolEnvironmentPic" v-for="(item, index) in webInfo.WidgetHome.part6.schoolEnvironmentPicList.c" :key="index" lazy :src="globalConfig.filePath + item" fit="cover"></el-image>
                    </template>
                    <template v-if="schoolEnvironmentTabActive == 4">
                        <el-image class="schoolEnvironmentPic" v-for="(item, index) in webInfo.WidgetHome.part6.schoolEnvironmentPicList.d" :key="index" lazy :src="globalConfig.filePath + item" fit="cover"></el-image>
                    </template>
                </div>
            </div>
            <el-image lazy style="width: 100%;display: block;margin: 10px 0 20px 0;" :src="globalConfig.filePath + webInfo.WidgetHome.part6.banner" fit="cover"></el-image>
        </div>

        <el-dialog :title="newsDetail.noticeName" :visible.sync="newsDialogVisible" width="90%" top="5vh" center>
            <div class="newsDetail">
                <div v-html="newsDetail.noticeContent"></div>
            </div>
            <span slot="footer" class="dialog-footer" v-if="1 == 2">
                <el-button @click="newsDialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                webInfo: null,
                majorButtonActive: 0,
                timer: null,
                teacherType: null,
                schoolEnvironmentTabActive: 1,
                currentPage: 1,
                pageSize: 15,
                newsList: [],
                newsDialogVisible: false,
                newsDetail: {},
            };
        },
        updated() {},
        mounted() {
            var that = this;
            that.webInfo = that.$parent.webInfo;
            that.$nextTick(() => {
                that.rollUp();
            });
            that.getSysNoticeInfoPageList();
        },
        beforeDestroy() {
            this.timer = null;
            clearInterval(this.timer);
        },
        methods: {
            getSysNoticeInfoPageList: function () {
                //登录请求
                var that = this;
                //请求地址
                var url =
                    that.globalConfig.mainApi +
                    'sys/notice/getSysNoticeInfoPageList';

                //POST参数
                var postData = {
                    data: {
                        schoolId: that.globalConfig.schoolId,
                        currentPage: that.currentPage,
                        pageSize: that.pageSize,
                    },
                };

                postData = that.qs.parse(postData);

                that.axios
                    .post(url, postData)
                    .then(function (response) {
                        if (response.data.code == 1) {
                            that.newsList = response.data.data;
                        } else {
                            that.$message({
                                message: response.data.msg,
                                type: 'warning',
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getSysNoticeInfo(id) {
                //登录请求
                var that = this;
                //请求地址
                var url = that.globalConfig.mainApi + 'sys/notice/getSysNoticeInfo';

                //POST参数
                var postData = {
                    data: {
                        schoolId: that.globalConfig.schoolId,
                        id: id,
                    },
                };

                postData = that.qs.parse(postData);

                that.axios
                    .post(url, postData)
                    .then(function (response) {
                        if (response.data.code == 1) {
                            that.newsDetail = response.data.data;
                            that.newsDialogVisible = true;
                        } else {
                            that.$message({
                                message: response.data.msg,
                                type: 'warning',
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            newsDetailView(item) {
                var that = this;
                that.getSysNoticeInfo(item.id);
            },
            stopRollUp() {
                clearInterval(this.timer);
            },
            restartRollUp() {
                this.rollUp();
            },
            rollUp() {
                let enrollListDiv = document.getElementById('enrollListDiv');
                let enrollList = document.getElementById('enrollList');
                let enrollListCopy = document.getElementById('enrollListCopy');
                if (enrollListDiv.offsetHeight >= enrollList.offsetHeight) {
                    return false;
                }
                enrollListCopy.innerHTML = enrollList.innerHTML;
                enrollListDiv.scrollTop = enrollListDiv.scrollTop
                    ? enrollListDiv.scrollTop
                    : 0;
                function rollStart() {
                    if (enrollListDiv.scrollTop >= enrollList.scrollHeight) {
                        enrollListDiv.scrollTop = 0;
                    } else {
                        enrollListDiv.scrollTop++;
                    }
                }
                this.timer = setInterval(rollStart, 50);
            },
            backTop() {
                window.scrollTo(0, 0);
            },
        },
    };
</script>

<style scoped>
    .elementTitle {
        font-size: 32px;
        font-weight: bold;
        line-height: 60px;
        width: 100%;
        text-align: center;
    }

    .elementLabel {
        font-size: 16px;
        line-height: 30px;
        width: 100%;
        text-align: center;
    }

    .WidgetHomeHeaderDiv {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin: 20px auto;
    }

    .WidgetHomeHeader {
        display: flex;
        justify-content: center;
        line-height: 40px;
        padding: 10px 20px;
        box-sizing: border-box;
        border: 1px solid #ccc;
        width: 100%;
    }

    .WidgetHomeHeaderPic {
        height: 40px;
        width: 40px;
        min-width: 40px;
        display: block;
    }

    .WidgetHomeHeaderLabel {
        height: 40px;
        margin-left: 10px;
        font-size: 14px;
        overflow: hidden;
    }

    .detailsCard {
        width: 100%;
    }

    .detailsCard + .detailsCard {
        margin-left: 15px;
    }

    .detailsCard >>> img {
        transition: 0.3s;
    }

    .detailsCard >>> img:hover {
        transform: scale(1.1);
    }

    .imgLabel {
        background: #236de9;
        color: #fff;
        line-height: 40px;
        height: 40px;
        overflow: hidden;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0 10px;
        box-sizing: border-box;
    }

    .majorButton {
        width: 50%;
        background: #ccc;
        height: 60px;
        line-height: 60px;
        color: #000;
        text-align: center;
        font-size: 24px;
        cursor: pointer;
    }

    .majorButton:first-child {
        border-radius: 10px 0 0 0;
    }

    .majorButton:last-child {
        border-radius: 0 10px 0 0;
    }

    .majorButtonActive {
        background: #236de9;
        color: #fff;
    }

    .majorName {
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        line-height: 30px;
    }

    .majorDetails {
        height: 60px;
        overflow: hidden;
        margin: 10px 0;
        line-height: 20px;
        transition: 0.3s;
    }

    .majorCard {
        border-radius: 10px;
    }

    .majorCard:hover {
        transform: scale(1.02);
    }

    #enrollListDiv {
        width: calc(100% - 30px);
        height: 370px;
        margin: 0 auto;
        background: #fff;
        line-height: 30px;
        padding: 0 5px;
        box-sizing: border-box;
        text-align: center;
        overflow: hidden;
    }

    .enrollListInfo {
        border-bottom: 1px dotted #aaa;
        height: 30px;
        line-height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-spacing: normal;
        word-break: break-all;
        white-space: nowrap;
    }

    .enrollPicDiv {
        width: calc(100% - 30px);
        height: 265px;
        background: #fff;
        margin: 0 auto;
        margin-top: 15px;
        transition: 0.3s;
    }

    .enrollPicDiv:hover {
        transform: scale(1.02);
    }

    .aleiTable {
        width: 100%;
        line-height: 38px;
        text-align: center;
        font-size: 18px;
        margin: 10px auto;
        border-color: #e6e6e6;
        border: 1px solid #e6e6e6;
        border-collapse: collapse;
    }

    .aleiTable {
        overflow: hidden;
    }

    .aleiTable tr td {
        padding: 0 5px;
        overflow: hidden;
        min-width: 50px;
    }

    .aleiTable tr:nth-child(1),
    .aleiTableHeadTr {
        font-weight: bold;
        background-color: #f2f2f2;
    }

    .hotMajorPicDiv {
        display: flex;
        justify-content: space-around;
    }

    .hotMajorPic + .hotMajorPic {
        margin-left: 10px;
    }

    .hotMajorPic {
        height: 160px;
        width: 100%;
        display: block;
        transition: 0.3s;
    }

    .hotMajorPic:hover {
        transform: scale(1.02);
    }

    .advantageListDiv {
        margin: 10px 0;
    }

    .advantageList {
        display: flex;
    }

    .advantage {
        width: 25%;
        height: 250px;
        border: 1px solid #eee;
        padding: 10px 15px;
        box-sizing: border-box;
        position: relative;
    }

    .advantageTitle {
        width: 100%;
        font-size: 26px;
        color: #236de9;
        margin-bottom: 10px;
        font-weight: bold;
    }

    [advantageTitleIndex='1'],
    [advantageTitleIndex='3'],
    [advantageTitleIndex='5'],
    [advantageTitleIndex='7'] {
        color: #409eff !important;
    }

    .advantageLabel {
        width: 100%;
        font-size: 12px;
        height: 68px;
        line-height: 17px;
        overflow: hidden;
    }

    .advantageButton {
        width: 90px;
        height: 25px;
        line-height: 25px;
        border: 1px solid #236de9;
        color: #236de9;
        text-align: center;
        font-size: 14px;
        margin-top: 10px;
        background-color: #fff;
    }

    .advantagePic {
        position: absolute;
        bottom: 5px;
        right: 5px;
        z-index: -1;
    }

    .teacherListDiv {
        width: 100%;
        height: 400px;
        display: flex;
        overflow: hidden;
        margin: 10px 0 20px 0;
    }

    .teacherListDiv >>> img {
        transition: 0.3s;
    }

    .teacherListDiv >>> img:hover {
        transform: scale(1.1);
    }

    .teacherListRight {
        width: 300px;
        background: #236de9;
        text-align: center;
        padding: 15px;
        box-sizing: border-box;
    }

    .teacherListRightTitle {
        font-size: 28px;
        font-weight: bold;
        line-height: 50px;
        height: 50px;
        border: 2px solid #fff;
        color: #fff;
        margin: 10px 0 30px 0;
    }

    .teacherListRightMajor {
        font-size: 18px;
        line-height: 35px;
        height: 35px;
        color: #236de9;
        background-color: #fff;
        margin: 10px auto;
        width: 70%;
        border-radius: 20px;
        cursor: pointer;
        transition: 0.3s;
    }

    .teacherListRightMajor:hover {
        transform: scale(1.02);
    }

    .schoolEnvironmentPicList {
        display: grid;
        grid-template-columns: auto auto auto auto;
        grid-template-rows: auto auto auto auto;
    }

    .schoolEnvironmentPicList >>> img {
        transition: 0.3s;
    }

    .schoolEnvironmentPicList >>> img:hover {
        transform: scale(1.1);
    }

    .schoolEnvironmentPic {
        height: 190px;
        width: 100%;
        display: block;
    }

    .schoolEnvironmentDiv {
        margin: 10px 0 20px 0;
    }

    .schoolEnvironmentTabList {
        display: flex;
        justify-content: space-around;
        align-items: end;
    }

    .schoolEnvironmentTab {
        font-size: 22px;
        height: 45px;
        line-height: 45px;
        background-color: #ccc;
        width: 100%;
        text-align: center;
        border: 1px dotted #aaa;
        border-width: 0 1px;
        box-sizing: border-box;
        cursor: pointer;
    }

    .schoolEnvironmentTabActive {
        font-size: 32px;
        height: 65px;
        line-height: 65px;
        background-color: #236de9;
        color: #fff;
        border-radius: 10px 10px 0 0;
    }

    .newsDiv {
        width: 100%;
        height: 550px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
    }

    .newsBackground {
        height: 100%;
        width: 100%;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        opacity: 0.1;
    }

    .newsTitle {
        font-size: 24px;
        line-height: 24px;
        font-weight: bold;
        border-left: 10px solid #236de9;
        padding-left: 10px;
    }

    .newsHeader {
        width: 100%;
        margin-bottom: 20px;
    }

    .newsDetailsDiv {
        width: 100%;
    }

    .newsDetails {
        width: 100%;
        display: flex;
    }

    .newsDetails >>> img {
        transition: 0.3s;
    }

    .newsDetails >>> img:hover {
        transform: scale(1.1);
    }

    .newsDetailsTitle {
        font-size: 16px;
        font-weight: bold;
        line-height: 30px;
        height: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-inline-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: normal;
    }

    .newsDetailsContent {
        font-size: 14px;
        line-height: 25px;
        height: 50px;
        margin-top: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-inline-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: normal;
    }

    .newsNotice {
        width: 100%;
        background-color: #fff;
        margin-top: 30px;
    }

    .newsNoticeInfo {
        width: 100%;
        height: 50px;
        line-height: 50px;
        border-bottom: 1px dotted #eee;
        font-size: 16px;
        display: flex;
        overflow: hidden;
    }

    .newsMoreButton {
        font-size: 16px;
        line-height: 32px;
        height: 32px;
        width: 200px;
        border-radius: 5px;
        text-align: center;
        border: 1px solid #000;
        margin: 25px auto;
        font-weight: bold;
        cursor: pointer;
    }

    .newsDetail {
        width: 100%;
        height: 70vh;
        overflow: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/Widget/WidgetHome.vue